<div class="layout-page">
    <div class="confirm-block">
    <div class="logo-wrapper">
      <img src="/assets/images/login/ID.svg" alt="" />
    </div>
      @if(inconsistent?.length) {
      <div class="h3 confirm-block_title">
        НФ.ID запрашивает ваше разрешение на доступ<br />
        и использование следующих данных:
      </div>
    <ul class="confirm-block_list inter">
        @for(item of inconsistent;track item){
          <li>{{item.title}}</li>
        }
    </ul>
    <div class="confirm-block_buttons">
      <app-button (click)="confirmConsent()" title="принять"></app-button>
      <app-button (click)="cancel()" title="отклонить"></app-button>
    </div>
    <p class="inter">
      Нажимая "Принять", вы разрешаете приложению использовать <br />
      указанные данные в соответствии с
      <span class="confirm-link"
        >Политикой<br />
        конфиденциальности.</span
      >
    </p>
    } @else {
      <div class="h3 confirm-block_title">
        Данные отсутствуют
      </div>
      <ul class="confirm-block_list inter">
        <app-button (click)="cancel()" title="Вернуться"></app-button>
      </ul>
      }
  </div>
</div>
